import { render, staticRenderFns } from "./purchases-import.vue?vue&type=template&id=0726fd14"
import script from "./purchases-import.vue?vue&type=script&lang=js"
export * from "./purchases-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports